import {
  FETCH_ACTIVITYLIST_REQUEST,
    FETCH_ACTIVITYLIST_SUCCESS,
    FETCH_ACTIVITYLIST_FAILURE,
  } from "./ActivityListTypes";
  import api from "../../utils/Api";
  
  export const fetchActivityListRequest = () => {
    return {
      type: FETCH_ACTIVITYLIST_REQUEST,
    };
  };
  
  export const fetchActivityListSuccess = (activityList) => {
    return {
      type: FETCH_ACTIVITYLIST_SUCCESS,
      payload: activityList,
    };
  };
  
  export const fetchActivityListFailure = (error) => {
    return {
      type: FETCH_ACTIVITYLIST_FAILURE,
      payload: error,
    };
  };
  
  export const fetchActivityListing = (searchKey, sortBy, page) => {
    
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    return async (dispatch) => {
      dispatch(fetchActivityListRequest);
      try {
        const response = await api.get("user/activity/dropdown/fetch",
          {
            headers: headers,
          }
        );
        const activityList = response.data;
        dispatch(fetchActivityListSuccess(activityList));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchActivityListFailure(errorMsg));
      }
    };
  };
  